import getUserName from "./getUserName";

export const getName = (user: any, isProfile = false) => (isProfile ? "me" : getUserName(user, false));

export default getName;
